import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { HttpService, NotificationService } from '../../../tms-shared';
import { TmsWebBaseEditCreateCopyService } from '../base';
import {
  AddressLabel,
  CreatedSalesOrderFromContracts,
  CreditPassed,
  SalesOrderAnalysis,
  SalesOrderEmailContacts,
  SalesOrderHeader,
  SalesOrderHeaderDetails,
} from '../../models';

@Injectable({
  providedIn: 'root',
})
export class SalesOrderService extends TmsWebBaseEditCreateCopyService<SalesOrderHeader, SalesOrderHeaderDetails> {
  public refreshDetails = new Subject<void>();

  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super('SalesOrder', $localize`Sales Order Header`, httpService, notificationService);
  }

  getSalesOrderHeader(id: string): Observable<SalesOrderHeader> {
    return this.httpService.get<SalesOrderHeader>(`${this.apiUrl}/SalesOrder?id=${id}`);
  }

  getSalesOrderEmailContacts(id: string): Observable<SalesOrderEmailContacts> {
    return this.httpService.get<SalesOrderEmailContacts>(`${this.apiUrl}/SalesOrderEmailContacts?id=${id}`);
  }

  checkAutoCreatePO(id: string): Observable<boolean> {
    return this.httpService.get<boolean>(`${this.apiUrl}/CheckAutoCreatePO?id=${id}`);
  }

  getDeliveryAddress(id: string, salesDespatchNoteId: string): Observable<AddressLabel> {
    return this.httpService.get<AddressLabel>(
      `${this.apiUrl}/GetDeliveryAddress?id=${id}&salesDespatchNoteId=${salesDespatchNoteId}`,
    );
  }

  updateCreditPassed(creditPassed: CreditPassed): Observable<CreditPassed> {
    return this.httpService.post<CreditPassed>(`${this.apiUrl}/CreditPassed`, creditPassed);
  }

  createSalesOrderFromContracts(ids: string[], balances: number[]): Observable<string[]> {
    return this.httpService.post<string[]>(`${this.apiUrl}/CreateSalesOrderFromContracts`, { ids, balances });
  }

  createSalesOrderCustomerPortal(id: string): Observable<SalesOrderHeader> {
    return this.httpService.post<SalesOrderHeader>(`${this.apiUrl}/CreateSalesOrderFromCustomerPortal`, { id });
  }

  getSalesOrderAnalysis(fromDate: Date, toDate: Date, useDateEntered: boolean): Observable<SalesOrderAnalysis[]> {
    return this.httpService.get<SalesOrderAnalysis[]>(
      `${this.apiUrl}/SalesOrderAnalysis?fromDate=${fromDate.toISOString()}&toDate=${toDate.toISOString()}&useDateEntered=${useDateEntered}`,
    );
  }

  getCreatedSalesOrdersFromContracts(ids: string[]): Observable<CreatedSalesOrderFromContracts[]> {
    return this.httpService.post<CreatedSalesOrderFromContracts[]>(`${this.apiUrl}/CreatedSalesOrdersFromContracts`, {
      ids,
    });
  }
}
